module.exports = __webpack_public_path__ + "img/PDF_icon.ef815cb7.png";